import styled from "styled-components";
import { FileUploadView } from "./FileUploadView";
import StockSaveIcon from "@mui/icons-material/Save";
import { fontSizes } from "healthex-common/sizes";
import { HXButton } from "./HXButton";
import { HXTextField } from "./base.styles";
export const LogoUploadView = styled(FileUploadView) `
    width: 340px;
    height: 120px;
    align-self: flex-start;
`;
export const ButtonArea = styled.div `
    display: flex;
    gap: 20px;
    margin-top: 10px;
`;
export const SaveButton = styled(HXButton) `
    padding-left: 20px;
    padding-right: 20px;
`;
export const SaveIcon = styled(StockSaveIcon) `
    font-size: ${fontSizes.STANDARD} !important;
`;
export const VanitySubdomainInput = styled.div `
    vertical-align: middle;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;

    && ${HXTextField} {
        width: 200px;
    }
`;
export const VanitySubdomainPrefix = styled.div ``;
export const VanitySubdomainSuffix = styled.div ``;
